import { Dayjs } from "dayjs"
import { IWarrantsCommunication } from "@/models/admin/warrantsCommunication/warrantsCommunication.types"
import { sentenceCase } from "@/helpers/stringHelpers"

export class WarrantsCommunication implements IWarrantsCommunication {
  constructor(
    public id: number,
    public groupId: number,
    public commsId: string | null,
    public type: string,
    public deliveryStatus: string,
    public deliveryExternalStatus: string | null,
    public parentPriorityLevel: number,
    public errorDescription: string | null,
    public createdAt: Dayjs,
    public deletedAt: Dayjs | null,
  ) {}

  get isDeleted(): boolean {
    return this.deletedAt !== null
  }

  get typeDisplay(): string {
    return sentenceCase(this.type)
  }

  get deliveryStatusDisplay(): string {
    return sentenceCase(this.deliveryStatus)
  }
}
